import { render } from "./supplier-report.vue?vue&type=template&id=3cd16741"
import script from "./supplier-report.vue?vue&type=script&lang=js"
export * from "./supplier-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__